module.exports = "/static/assets/5a42040c1e433385beb301e60169cae4.png";